module.exports = __webpack_public_path__ + "img/product-icon.9eddeff5.png";